// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WebOperationListListResultModel from '../../model/web-operation-list-list-result-model';
import WebOperationListListResultDTO from '../dto/web-operation-list-list-result-dto';
import dtoSchema from '../schemas/web-operation-list-list-result-schema';
import WebOperationListModel from '../../model/web-operation-list-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class WebOperationListListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WebOperationListListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => WebOperationListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: WebOperationListModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<WebOperationListListResultDTO>): WebOperationListListResultModel;
  static toModel(dto: DeepPartial<WebOperationListListResultDTO> | undefined | null): WebOperationListListResultModel | undefined;
  static toModel(dto: DeepPartial<WebOperationListListResultDTO> | undefined | null): WebOperationListListResultModel | undefined {
    return dto ? new WebOperationListListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WebOperationListListResultModel> | WebOperationListListResultModel): WebOperationListListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as WebOperationListListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WebOperationListListResultModel, can not map to WebOperationListListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
